(function () {
  'use strict';

  var KLAVIYO_COMPANY_ID = 'R2FDJA';
  var KLAVIYO_LIST_ID = 'X5FqnR';
  var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];

  function safeStorage(storage, action, key, value) {
    try {
      if (action === 'get') return storage.getItem(key);
      storage.setItem(key, value);
    } catch (error) {}
    return null;
  }

  function captureAttribution() {
    var params = new URLSearchParams(window.location.search);
    ATTR_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) safeStorage(window.localStorage, 'set', 'fza_' + key, value);
    });
    if (!safeStorage(window.localStorage, 'get', 'fza_first_landing_page')) {
      safeStorage(window.localStorage, 'set', 'fza_first_landing_page', window.location.href);
      safeStorage(window.localStorage, 'set', 'fza_first_referrer', document.referrer || 'direct');
    }
  }

  function attribution() {
    var values = {
      fza_first_landing_page: safeStorage(window.localStorage, 'get', 'fza_first_landing_page') || window.location.href,
      fza_first_referrer: safeStorage(window.localStorage, 'get', 'fza_first_referrer') || document.referrer || 'direct'
    };
    ATTR_KEYS.forEach(function (key) {
      var value = safeStorage(window.localStorage, 'get', 'fza_' + key);
      if (value) values['fza_' + key] = value;
    });
    return values;
  }

  function marketingAllowed() {
    try {
      if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.marketingAllowed === 'function') {
        return Shopify.customerPrivacy.marketingAllowed();
      }
    } catch (error) {}
    return true;
  }

  function simpleHash(value) {
    var hash = 2166136261;
    for (var i = 0; i < value.length; i += 1) {
      hash ^= value.charCodeAt(i);
      hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }
    return (hash >>> 0).toString(36);
  }

  function fireMetaLead(email, source) {
    if (!marketingAllowed() || typeof window.fbq !== 'function') return;
    var key = 'fza_meta_lead_' + simpleHash(email.toLowerCase());
    if (safeStorage(window.sessionStorage, 'get', key)) return;
    var eventId = 'fza_lead_' + Date.now() + '_' + simpleHash(email.toLowerCase());
    window.fbq('track', 'Lead', {
      content_name: 'freleza_email_signup',
      content_category: source,
      value: 0,
      currency: 'USD'
    }, { eventID: eventId });
    safeStorage(window.sessionStorage, 'set', key, eventId);
  }

  function klaviyoIdentify(properties) {
    window._learnq = window._learnq || [];
    window._learnq.push(['identify', properties]);
  }

  function subscribe(email, properties) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: properties.fza_signup_source,
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email, properties: properties }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
        }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo signup failed with status ' + response.status);
      return response;
    });
  }

  function saveZip(email, zip) {
    return fetch('https://a.klaviyo.com/client/profiles?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        revision: '2026-07-15'
      },
      body: JSON.stringify({
        data: {
          type: 'profile',
          attributes: {
            email: email,
            location: { zip: zip },
            properties: { fza_zip: zip }
          }
        }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo ZIP update failed with status ' + response.status);
      return response;
    });
  }

  function initSignup(wrap) {
    var form = wrap.querySelector('[data-fza-signup]');
    var locationState = wrap.querySelector('[data-fza-location]');
    var completeState = wrap.querySelector('[data-fza-complete]');
    var zipForm = wrap.querySelector('[data-fza-zip-form]');
    var skip = wrap.querySelector('[data-fza-skip-zip]');
    var email = '';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var error = form.querySelector('[data-fza-error]');
      var button = form.querySelector('button[type="submit"]');
      email = input.value.trim();
      error.hidden = true;
      if (!input.checkValidity()) {
        input.reportValidity();
        return;
      }
      button.disabled = true;
      button.textContent = 'Joining...';
      var properties = Object.assign(attribution(), {
        fza_signup_source: form.dataset.source || 'Website',
        fza_signup_page_url: window.location.href,
        fza_signup_page_type: form.dataset.pageType || 'page',
        fza_signup_intent: form.dataset.intent || 'Launch updates',
        fza_flavor_interest: form.dataset.flavor || '',
        audience_origin: 'Freleza'
      });
      subscribe(email, properties).then(function () {
        klaviyoIdentify(Object.assign({ '$email': email }, properties));
        window._learnq.push(['track', 'Freleza Signup', properties]);
        fireMetaLead(email, properties.fza_signup_source);
        form.hidden = true;
        locationState.hidden = false;
        var dialogIntro = wrap.closest('[data-fza-dialog]');
        if (dialogIntro) {
          var intro = dialogIntro.querySelector('[data-fza-dialog-intro]');
          if (intro) intro.hidden = true;
        }
      }).catch(function () {
        error.textContent = 'Something went wrong. Please try again.';
        error.hidden = false;
      }).finally(function () {
        button.disabled = false;
        button.textContent = 'Join the list';
      });
    });

    zipForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = zipForm.querySelector('input[name="zip"]');
      var error = zipForm.querySelector('[data-fza-zip-error]');
      var button = zipForm.querySelector('button[type="submit"]');
      error.hidden = true;
      if (!input.checkValidity()) {
        input.reportValidity();
        return;
      }
      button.disabled = true;
      button.textContent = 'Saving...';
      saveZip(email, input.value).then(function () {
        klaviyoIdentify({ '$email': email, '$zip': input.value, fza_zip: input.value });
        locationState.hidden = true;
        completeState.hidden = false;
      }).catch(function () {
        error.textContent = 'We could not save your ZIP code. Please try again.';
        error.hidden = false;
      }).finally(function () {
        button.disabled = false;
        button.textContent = 'Keep me posted';
      });
    });

    skip.addEventListener('click', function () {
      locationState.hidden = true;
      completeState.hidden = false;
    });
  }

  function initDialog() {
    var dialog = document.querySelector('[data-fza-dialog]');
    if (!dialog) return;
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-open-join]');
      if (!opener) return;
      event.preventDefault();
      var form = dialog.querySelector('[data-fza-signup]');
      if (opener.dataset.flavor) form.dataset.flavor = opener.dataset.flavor;
      dialog.showModal();
    });
    dialog.querySelector('[data-fza-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
  }

  function initHero(hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.heroSlide'));
    var toggle = hero.querySelector('[data-fza-hero-toggle]');
    var active = 0;
    var paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = Boolean(navigator.connection && navigator.connection.saveData);
    var timer;
    function show(index) {
      clearTimeout(timer);
      slides.forEach(function (slide, i) {
        slide.hidden = i !== index;
        slide.classList.toggle('active', i === index);
        var video = slide.querySelector('video');
        if (video && i !== index) { video.pause(); video.currentTime = 0; }
      });
      active = index;
      if (paused) return;
      var slide = slides[active];
      var video = slide.querySelector('video');
      if (video && !saveData) {
        var source = video.querySelector('source[data-src]');
        if (source && !source.src) { source.src = source.dataset.src; video.load(); }
        video.onended = next;
        video.onerror = next;
        video.play().catch(next);
      } else {
        timer = setTimeout(next, Number(slide.dataset.duration || 5000));
      }
    }
    function next() { show((active + 1) % slides.length); }
    toggle.addEventListener('click', function () {
      paused = !paused;
      toggle.textContent = paused ? 'Play' : 'Pause';
      if (paused) {
        clearTimeout(timer);
        var video = slides[active].querySelector('video');
        if (video) video.pause();
      } else show(active);
    });
    if (paused) toggle.hidden = true;
    show(0);
  }

  function initGallery(gallery) {
    var track = gallery.querySelector('.flavorGalleryTrack');
    var slides = Array.prototype.slice.call(track.children);
    var dots = gallery.querySelector('.galleryDots');
    slides.forEach(function (_, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = index === 0 ? 'active' : '';
      dot.setAttribute('aria-label', 'View image ' + (index + 1));
      dot.addEventListener('click', function () { track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' }); });
      dots.appendChild(dot);
    });
    function move(direction) { track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' }); }
    gallery.querySelector('[data-gallery-prev]').addEventListener('click', function () { move(-1); });
    gallery.querySelector('[data-gallery-next]').addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', function () {
      var index = Math.round(track.scrollLeft / track.clientWidth);
      Array.prototype.forEach.call(dots.children, function (dot, i) { dot.classList.toggle('active', i === index); });
    }, { passive: true });
  }

  function initFruit(carousel) {
    var image = carousel.querySelector('img');
    var sources = [
      ['fruit-passionfruit.webp', 'Fresh passionfruit'],
      ['fruit-mango.webp', 'Fresh mango'],
      ['fruit-pineapple.webp', 'Fresh pineapple'],
      ['fruit-guava.webp', 'Fresh guava'],
      ['fruit-coconut.webp', 'Fresh coconut']
    ];
    var base = image.src.replace(/fruit-[^/?]+\.webp.*$/, '');
    var index = 0;
    setInterval(function () {
      index = (index + 1) % sources.length;
      image.src = base + sources[index][0];
      image.alt = sources[index][1];
    }, 2800);
  }

  document.addEventListener('DOMContentLoaded', function () {
    captureAttribution();
    document.querySelectorAll('[data-fza-signup-wrap]').forEach(initSignup);
    document.querySelectorAll('[data-fza-hero]').forEach(initHero);
    document.querySelectorAll('[data-fza-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-fza-fruit]').forEach(initFruit);
    initDialog();
  });
})();
